import React from 'react';

export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.375rem"
      height="1.375rem"
      viewBox="0 0 17 18"
      version="1.1">
      <title>Download</title>
      <g
        id="Download-Icon"
        stroke="none"
        strokeWidth="0.7"
        fill="none"
        fillRule="evenodd">
        <g
          id="Header"
          transform="translate(-1350, -16)"
          fill="#54617A"
          fillRule="nonzero">
          <g transform="translate(37, 8)" id="Group-2">
            <g transform="translate(1304, 0)">
              <g id="noun-download-7322160" transform="translate(9.5, 8)">
                <path
                  d="M14.8642561,11.008858 C14.6033996,11.008858 14.3530911,11.1129198 14.1688607,11.2971466 C13.9846483,11.482061 13.8812741,11.7323875 13.8819761,11.993244 L13.8819761,16.0326321 L1.96541231,16.0326321 L1.96541231,11.993244 C1.98931815,11.7190314 1.89650637,11.4469069 1.7101718,11.2437045 C1.52383542,11.0405021 1.2601709,10.9244918 0.984554344,10.9244918 C0.708937793,10.9244918 0.445957267,11.0405075 0.259638894,11.2437045 C0.0726005204,11.4469069 -0.0202076652,11.7190134 0.00369638261,11.993244 L0.00369638261,17.015614 C0.00369638261,17.5570191 0.441043257,17.997174 0.983150342,18 L14.8642381,18 C15.4063452,17.9971875 15.8436921,17.5570371 15.8436921,17.015614 L15.8436921,11.993244 C15.8436921,11.4518389 15.4063452,11.011684 14.8642381,11.008858 L14.8642561,11.008858 Z"
                  id="Path"
                />
                <path
                  d="M7.22900083,14.2200644 C7.6129056,14.6039692 8.23446484,14.6039692 8.61838761,14.2200644 L13.5233974,9.31289463 C13.7125418,9.12938426 13.82011,8.87765376 13.8222655,8.61469123 C13.8243434,8.3510267 13.72028,8.0978922 13.5339454,7.91085382 C13.3476091,7.72451745 13.0944926,7.62045924 12.83153,7.62256525 C12.5678655,7.62397159 12.316135,7.73155006 12.1319226,7.91997984 L8.90811619,11.1459463 L8.90811619,0.984385969 C8.90811619,0.440874882 8.46725931,0 7.92373022,0 C7.38020114,0 6.93934425,0.440856882 6.93934425,0.984385969 L6.93934425,11.1459463 L3.71553781,7.91997984 C3.32742103,7.56068112 2.72413182,7.57193114 2.35007308,7.94599529 C1.97601433,8.32005944 1.9647643,8.92334325 2.32405762,9.31146002 L7.22900083,14.2200644 Z"
                  id="Path"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
